var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "umesr-page" },
    [
      _c("page-header", {
        staticClass: "umesr-page__page-header",
        attrs: {
          actions: _vm.pageHeaderActionsConfig,
          "left-side-class": "col-xl-4",
          page: _vm.pageHeaderConfig,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-2 justify-content-end"
        }
      }),
      _c("filter-manager", {
        staticClass: "umesr-page__filter-manager",
        attrs: { filters: _vm.filtersConfig },
        on: { search: _vm.search },
        model: {
          value: _vm.selectedFilters,
          callback: function($$v) {
            _vm.selectedFilters = $$v
          },
          expression: "selectedFilters"
        }
      }),
      _c("custom-separator", {
        staticClass: "pt-3 my-4",
        attrs: { text: "Resultados" }
      }),
      _c("umesr-list", {
        on: { "on-delete": _vm.onDeleteHandler },
        model: {
          value: _vm.results,
          callback: function($$v) {
            _vm.results = $$v
          },
          expression: "results"
        }
      }),
      _vm.results.length === 0
        ? _c("custom-result-not-found", {
            attrs: { text: "No se encontraron hallazgos en el sistema" }
          })
        : _vm._e(),
      _vm.results.length > 0 && _vm.pagination.totalItemCount > _vm.pageSize
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": true },
            on: { "pagination-go-page": _vm.goToPageHandler }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }